import {OrderHistoryError} from 'app/core/components/error-page/order-history-error';
import {createReducer, on} from '@ngrx/store';
import {ErrorActions} from 'app/core/components/error-page/state/error.actions';

export const ERROR_FEATURE_KEY = 'errors';

export interface ErrorState {
  error: OrderHistoryError | undefined;
}

export const initialErrorState: ErrorState = {
  error: undefined,
};

export const errorReducer = createReducer(
  initialErrorState,
  on(ErrorActions.directToErrorPage, (state, {error}) => {
    return {...state, error};
  })
);

export const getError = (state: ErrorState) => state.error;
